import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme/index'

export const FlexWrapper = styled(Flex)`
  margin: 15px 0 0;
  width: 100%;
  gap: 10px;
`

export const NotifyText = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: ${COLORS.GREY_T_20};
`
export const NotifyTexBold = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  color: #4d566e;
  text-transform: capitalize;
`
export const ButtonFlex = styled(Flex)`
  gap: 10px;
`
export const LightText = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: ${COLORS.GREY_T_60};
`
export const NotifyDiv = styled.div`
  .infinite-scroll-component {
    ::-webkit-scrollbar {
      display: none !important;
    }
  }
`
export const InfoWrap = styled(Flex)`
  gap: 10px;
`
export const BottomFLex = styled(Flex)`
  gap: 8px;
`
